import client from './client';

export const analyticsApi = {
  getOverview: (range?: number) =>
    client.get('/api/admin/analytics/overview', { params: range ? { range } : {} }),

  getUserGrowth: (period = 'day', range = 90) =>
    client.get('/api/admin/analytics/users/growth', { params: { period, range } }),

  getUsersByStatus: () =>
    client.get('/api/admin/analytics/users/by-status'),

  getUsersByRegion: () =>
    client.get('/api/admin/analytics/users/by-region'),

  getRevenueOverview: (startDate?: string, endDate?: string) =>
    client.get('/api/admin/analytics/revenue/overview', { params: { start_date: startDate, end_date: endDate } }),

  getRevenueHistory: (startDate?: string, endDate?: string, period = 'month') =>
    client.get('/api/admin/analytics/revenue/history', { params: { start_date: startDate, end_date: endDate, period } }),

  getContentOverview: () =>
    client.get('/api/admin/analytics/content/overview'),

  getContentActivity: (range = 90, period = 'day') =>
    client.get('/api/admin/analytics/content/activity', { params: { range, period } }),

  getTopSpecies: (type = 'plant', limit = 20) =>
    client.get('/api/admin/analytics/content/top-species', { params: { type, limit } }),

  getEngagement: () =>
    client.get('/api/admin/analytics/engagement'),

  getMostActiveUsers: (sort = 'activity', limit = 25) =>
    client.get('/api/admin/analytics/users/most-active', { params: { sort, limit } }),
};
